import type { TOC } from '@ember/component/template-only';
import { PrismModal } from '@mylighthouse/prism-ember';
import HotelEventsFormsFormEditEvent from 'lumen/components/hotel/events/forms/form-edit-event';
import type HotelEventsEditController from 'lumen/controllers/hotel/events/edit';

interface HotelEventsEditSignature {
  Args: {
    controller: HotelEventsEditController;
    model: unknown;
  };
}

<template>
  <PrismModal
    @onClose={{@controller.redirectOnClose}}
    @title={{@controller.title}}
  >
    <div class="modal--small">
      <HotelEventsFormsFormEditEvent
        @addExistingEvent={{@controller.addExistingEvent}}
        @closeModal={{@controller.redirectOnClose}}
        @fetchSearchResult={{@controller.fetchSearchResult}}
        @initialDate={{@controller.initialDate}}
        @saveNewEvent={{@controller.saveNewEvent}}
        @searchResults={{@controller.searchResults}}
      />
    </div>
  </PrismModal>
</template> satisfies TOC<HotelEventsEditSignature>;
